import { render, staticRenderFns } from "./CustomLogs.vue?vue&type=template&id=0f16b250&scoped=true"
import script from "./CustomLogs.vue?vue&type=script&lang=js"
export * from "./CustomLogs.vue?vue&type=script&lang=js"
import style0 from "./CustomLogs.vue?vue&type=style&index=0&id=0f16b250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16b250",
  null
  
)

export default component.exports